import BaseError from './base-error'

class PrefixError extends BaseError {
}

export default PrefixError
